import React, { useEffect, useState } from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import LicenseOverview from "./LicenseOverview"
import LicensePacks from "./LicensePacks"
import LicenseModels from "./LicenseModels"
import Licenses from "./Licenses"
import Value from "aldoo-ra/Value"
import Typography from "aldoo-ra/Typography"

const ProductLicensingHome = () => {
  // State for tracking license statistics
  const [statistics, setStatistics] = Value("license-statistics", null)
  const [pendingCount, setPendingCount] = useState(0)

  // Update pending count when statistics change
  useEffect(() => {
    if (statistics && statistics.licenses) {
      // Show free licenses count as pending
      setPendingCount(statistics.licenses.free || 0)
    } else {
      setPendingCount(0)
    }
  }, [statistics])

  // Custom tab resolver function
  const customTabResolver = (defaultTab, context, pathname) => {
    // Check if we're on a specific license page
    if (pathname.includes("/admin/product-licensing/licenses/")) {
      return "licenses"
    }
    // Check if we're on a specific pack page
    if (pathname.includes("/admin/product-licensing/packs/")) {
      return "packs"
    }
    // Check if we're on a specific model page
    if (pathname.includes("/admin/product-licensing/models/")) {
      return "models"
    }
    return undefined
  }

  return (
    <SidePanelLayout
      menuName="AdminProductLicensingMenu"
      tabs={{
        overview: LicenseOverview,
        packs: LicensePacks,
        models: LicenseModels,
        licenses: Licenses,
      }}
      tabResolver={customTabResolver}
      onMenuItemRender={(item) => {
        // Show badge for licenses menu item if there are free licenses
        if (item.name !== "AdminProductLicensingLicenses") return null
        if (pendingCount <= 0) return null

        return (
          <div className="min-w-[20px] h-5 flex items-center justify-center rounded-full bg-admin_primary px-1.5">
            <Typography variant="admin_txt2" className="text-white">
              {pendingCount > 99 ? "99+" : pendingCount}
            </Typography>
          </div>
        )
      }}
    />
  )
}

export default ProductLicensingHome
